module.exports = __webpack_public_path__ + "static/media/image_namecard.d38cba5c.png";